import React from "react";
import Table from "react-bootstrap/Table";
import "./DetaljiTable.css";
import { PaperClipOutlined, ZoomInOutlined } from "@ant-design/icons";
import ButtonComponent from "../UI/ButtonComponent/ButtonComponent";
import RazlogBrisanjaComponent from "./RazlogBrisanjaComponent";

const RevizorskaDrustvaDrugihDrzavaClanicaDetaljiTable = (props) => {
  let drustvo;
  let adresaDrustva = [];
  let registracijaDrustva = [];
  let kontaktDrustva = [];
  let osobaDrustvo = [];
  let revizijskiPartner = [];
  let clanDrustva = [];
  let mreza = [];
  let clanMreze = [];
  let mjere = [];

  let dionicari = [];
  let clanoviUprave = [];

  let registracijaHr = [];
  let odobrenjeMaticnaDrzava = [];
  let regDrustvaDrugeDrzave = [];
  let regDrustvaTrecaZemlja = [];
  let regDrustvaNadzor = [];

  let adresaDrustvaMaticna = [];
  let adresaDrustvaHr = [];
  let adresaUreda = [];

  let registar = props.children;

  drustvo = registar[1];
  adresaDrustva = registar[2];
  registracijaDrustva = registar[3];
  kontaktDrustva = registar[4];
  osobaDrustvo = registar[5];
  revizijskiPartner = registar[6];
  clanDrustva = registar[7];
  mreza = registar[8];
  clanMreze = registar[9];
  mjere = registar[11];

  dionicari = clanDrustva.filter((x) => x.vrClana == 1);

  clanoviUprave = clanDrustva.filter((x) => x.vrClana == 2);

  registracijaHr = registracijaDrustva.filter((x) => x.vrRegistracije == 1)[0];

  odobrenjeMaticnaDrzava = registracijaDrustva.filter(
    (x) => x.vrRegistracije == 1
  )[1];

  regDrustvaDrugeDrzave = registracijaDrustva.filter(
    (x) => x.vrRegistracije == 2
  );

  regDrustvaTrecaZemlja = registracijaDrustva.filter(
    (x) => x.vrRegistracije == 3
  );

  regDrustvaNadzor = registracijaDrustva.filter((x) => x.vrRegistracije == 4);

  adresaDrustvaMaticna = adresaDrustva.filter((x) => x.vrAdr == 1)[0];

  adresaDrustvaHr = adresaDrustva.filter((x) => x.vrAdr == 1)[1];

  adresaUreda = adresaDrustva.filter((x) => x.vrAdr === 2);

  let clanoviMreze = clanMreze.filter((x) => x.vrClana === 1);
  let povezanaDrustva = clanMreze.filter((x) => x.vrClana === 2);

  const noDataMessage = "";

  const { userRole } = props;

  const checkIfUserIsAdmin =
    userRole === "ROLE_REFERENT" || userRole === "ROLE_SLUZBENIK";

  return (
    <div id="printArea">
      {drustvo.napomena ? (
        <RazlogBrisanjaComponent razlog={drustvo.napomena} />
      ) : null}
      <h5>Pregled podataka</h5>
      <Table bordered hover responsive>
        <thead>
          <tr className="tr_table">
            <th scope="col">Naziv</th>
            <th scope="col">Identifikacijski broj</th>
            <th scope="col">
              Registarski broj iz registra matične države članice
            </th>
            <th scope="col">Pravni oblik</th>
            <th scope="col">
              Broj i datum registracije koju je odobrilo Ministarstvo financija
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{drustvo.nazDrustva}</td>
            <td>{drustvo.idBroj}</td>
            <td>{drustvo.brRegOrig}</td>
            <td>{drustvo.pravniOblik}</td>
            <td>
              <table>
                <tbody>
                  <tr>
                    <td className="inner-td">
                      <b>Broj registracije: </b>
                      {drustvo.regBroj}
                    </td>
                  </tr>
                  <tr>
                    <td className="inner-td">
                      <b>Datum registracije: </b>
                      {registracijaHr.datReg && registracijaHr.datReg}
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </Table>

      <h5>Adrese</h5>
      <Table responsive bordered hover>
        <thead>
          <tr className="tr_table">
            <th scope="col">Matična adresa sjedišta</th>
            <th scope="col">Poslovna adresa u RH</th>
            <th scope="col">Adresa svakog ureda</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <table>
                <tbody>
                  {adresaDrustvaMaticna.ulicaKbr ? (
                    <tr>
                      <td className="inner-td">
                        <b>Ulica i kbr: </b>
                        {adresaDrustvaMaticna.ulicaKbr}
                      </td>
                    </tr>
                  ) : null}
                  {adresaDrustvaMaticna.brPoste ||
                  adresaDrustvaMaticna.nazNaselja ? (
                    <tr>
                      <td className="inner-td">
                        <b>Grad: </b>
                        {adresaDrustvaMaticna.brPoste}
                        {adresaDrustvaMaticna.nazNaselja &&
                          " " + adresaDrustvaMaticna.nazNaselja}
                      </td>
                    </tr>
                  ) : null}
                  {adresaDrustvaMaticna.drzava ? (
                    <tr>
                      <td className="inner-td">
                        <b>Država: </b>
                        {adresaDrustvaMaticna.drzava}
                      </td>
                    </tr>
                  ) : null}
                </tbody>
              </table>
            </td>
            <td>
              <table>
                <tbody>
                  {adresaDrustvaHr.ulicaKbr ? (
                    <tr>
                      <td className="inner-td">
                        <b>Ulica i kbr: </b>
                        {adresaDrustvaHr.ulicaKbr}
                      </td>
                    </tr>
                  ) : null}
                  {adresaDrustvaHr.brPoste || adresaDrustvaHr.nazNaselja ? (
                    <tr>
                      <td className="inner-td">
                        <b>Grad: </b>
                        {adresaDrustvaHr.brPoste}
                        {adresaDrustvaHr.nazNaselja &&
                          " " + adresaDrustvaHr.nazNaselja}
                      </td>
                    </tr>
                  ) : null}
                  {adresaDrustvaHr.drzava ? (
                    <tr>
                      <td className="inner-td">
                        <b>Država: </b>
                        {adresaDrustvaHr.drzava}
                      </td>
                    </tr>
                  ) : null}
                </tbody>
              </table>
            </td>
            <td className="hr-divider">
              {adresaUreda.length > 0
                ? adresaUreda.map((adrUred, index) => (
                  <>
                    {adrUred.ulicaKbr
                      &&
                      (
                        adrUred.brPoste
                        ||
                        adrUred.nazNaselja
                      )
                      &&
                      adrUred.drzava
                      ?
                      (
                        <>
                          <table key={`adresa-ureda${index}`}>
                            <tbody>
                              {adrUred.ulicaKbr ? (
                                <tr>
                                  <td className="inner-td">
                                    <b>Ulica i kbr: </b>
                                    {adrUred.ulicaKbr}
                                  </td>
                                </tr>
                              ) : (
                                <tr>
                                  <td>{noDataMessage}</td>
                                </tr>
                              )}
                              {adrUred.brPoste || adrUred.nazNaselja ? (
                                <tr>
                                  <td className="inner-td">
                                    <b>Grad: </b>
                                    {adrUred.brPoste}
                                    {adrUred.nazNaselja && " " + adrUred.nazNaselja}
                                  </td>
                                </tr>
                              ) : null}
                              {adrUred.drzava ? (
                                <tr>
                                  <td className="inner-td">
                                    <b>Država: </b>
                                    {adrUred.drzava}
                                  </td>
                                </tr>
                              ) : null}
                            </tbody>
                          </table>
                          <hr />
                        </>
                      ) : null
                    }
                  </>
                  ))
                : noDataMessage}
            </td>
          </tr>
        </tbody>
      </Table>

      <h5>
        Odobrenja za rad izdana od nadležnog tijela matične države članice
      </h5>
      <Table responsive bordered hover>
        <thead>
          <tr className="tr_table">
            <th scope="col">Naziv nadležnog tijela</th>
            <th scope="col">Adresa nadležnog tijela</th>
            <th scope="col">Broj i datum odobrenja za rad</th>
          </tr>
        </thead>
        <tbody>
          {!odobrenjeMaticnaDrzava.brReg &&
          !odobrenjeMaticnaDrzava.datReg &&
          !odobrenjeMaticnaDrzava.nazTijela &&
          !odobrenjeMaticnaDrzava.ulicaKbr &&
          !odobrenjeMaticnaDrzava.brPoste &&
          !odobrenjeMaticnaDrzava.nazNaselja ? (
            <tr>
              <td colSpan="3"></td>
            </tr>
          ) : (
            <tr>
              <td>
                {odobrenjeMaticnaDrzava.nazTijela
                  ? odobrenjeMaticnaDrzava.nazTijela
                  : noDataMessage}
              </td>
              <td>
                <table>
                  <tbody>
                    {odobrenjeMaticnaDrzava.ulicaKbr ? (
                      <tr>
                        <td className="inner-td">
                          <b>Ulica i kbr: </b>
                          {odobrenjeMaticnaDrzava.ulicaKbr}
                        </td>
                      </tr>
                    ) : null}
                    {odobrenjeMaticnaDrzava.brPoste ||
                    odobrenjeMaticnaDrzava.nazNaselja ? (
                      <tr>
                        <td className="inner-td">
                          <b>Grad: </b>
                          {odobrenjeMaticnaDrzava.brPoste}
                          {odobrenjeMaticnaDrzava.nazNaselja &&
                            " " + odobrenjeMaticnaDrzava.nazNaselja}
                        </td>
                      </tr>
                    ) : null}
                    {odobrenjeMaticnaDrzava.nazivDrzave ? (
                      <tr>
                        <td className="inner-td">
                          <b>Država: </b>
                          {odobrenjeMaticnaDrzava.nazivDrzave}
                        </td>
                      </tr>
                    ) : null}
                  </tbody>
                </table>
              </td>
              <td>
                <table>
                  <tbody>
                    <tr>
                      <td className="inner-td">
                        <b>Broj odobrenja za rad: </b>
                        {odobrenjeMaticnaDrzava.brReg
                          ? odobrenjeMaticnaDrzava.brReg
                          : noDataMessage}
                      </td>
                    </tr>
                    <tr>
                      <td className="inner-td">
                        <b>Datum odobrenja za rad: </b>
                        {odobrenjeMaticnaDrzava.datReg
                          ? odobrenjeMaticnaDrzava.datReg
                          : noDataMessage}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          )}
        </tbody>
      </Table>

      <h5>Kontakt podaci</h5>
      <Table responsive bordered hover>
        <thead>
          <tr className="tr_table">
            <th scope="col">Kontakt</th>
          </tr>
        </thead>
        <tbody>
          {kontaktDrustva.length > 0 ? (
            kontaktDrustva.map((kontaktDrustvo, index) =>
              !kontaktDrustvo.ime &&
              !kontaktDrustvo.prezime &&
              !kontaktDrustvo.telefon &&
              !kontaktDrustvo.web &&
              !kontaktDrustvo.email ? (
                <tr key={`kontakt-drustva`}>
                  <td></td>
                </tr>
              ) : (
                <tr key={`kontakt-drustva${index}`}>
                  <td x-ms-format-detection="none">
                    <div>
                      {kontaktDrustvo.ime ? kontaktDrustvo.ime : null}{" "}
                      {kontaktDrustvo.prezime ? kontaktDrustvo.prezime : null}
                    </div>
                    <div>
                      {kontaktDrustvo.telefon ? (
                        <>
                          <b>telefon: </b>
                          {kontaktDrustvo.telefon}
                        </>
                      ) : null}
                    </div>
                    <div>
                      {kontaktDrustvo.web ? (
                        <>
                          <b>web: </b>
                          {kontaktDrustvo.web}
                        </>
                      ) : null}
                    </div>
                    <div>
                      {kontaktDrustvo.email ? (
                        <>
                          <b>email: </b>
                          {kontaktDrustvo.email}
                        </>
                      ) : null}
                    </div>
                  </td>
                </tr>
              )
            )
          ) : (
            <tr key={`kontakt-drustva`}>
              <td></td>
            </tr>
          )}
        </tbody>
      </Table>

      <h5>
        Ovlašteni revizori koji su zaposleni u revizorskom društvu, ili su s
        njime povezani kao partner ili na drugi način
      </h5>
      <Table responsive bordered hover>
        <thead>
          <tr className="tr_table">
            <th scope="col">Ime i prezime</th>
            <th scope="col">Registarski broj</th>
            <th scope="col">Detalji</th>
          </tr>
        </thead>
        <tbody>
          {osobaDrustvo.length > 0 ? (
            osobaDrustvo.map((ovlRevizor, index) => (
              <tr key={`osoba-drustvo${index}`}>
                <td>
                  {ovlRevizor.imeOsobe} {ovlRevizor.prezimeOsobe}
                </td>
                <td>{ovlRevizor.regBrojOsobe}</td>
                <td className="ant_batn">
                  <ButtonComponent
                    variant="secondary"
                    onClick={(e) =>
                      props.detaljiSecondaryClicked(
                        "osoba",
                        ovlRevizor.idOsobe,
                        ovlRevizor.vrOsobe,
                        false
                      )
                    }
                  >
                    <ZoomInOutlined />
                  </ButtonComponent>
                </td>
              </tr>
            ))
          ) : (
            <tr key={`osoba-drustvo`}>
              <td colSpan="3"></td>
            </tr>
          )}
        </tbody>
      </Table>

      <h5>
        Glavni revizijski partner koji obavlja zakonsku reviziju u ime
        revizorskog društva u Republici Hrvatskoj
      </h5>
      <Table responsive bordered hover>
        <thead>
          <tr className="tr_table">
            <th scope="col">Ime i prezime</th>
            <th scope="col">Registarski broj</th>
            <th scope="col">Detalji</th>
          </tr>
        </thead>
        <tbody>
          {revizijskiPartner.length > 0 ? (
            revizijskiPartner.map((revPartner, index) => (
              <tr key={`osoba-drustvo${index}`}>
                <td>
                  {revPartner.imeOsobe} {revPartner.prezimeOsobe}
                </td>
                <td>{revPartner.regBrojOsobe}</td>
                <td className="ant_batn">
                  <ButtonComponent
                    variant="secondary"
                    onClick={(e) =>
                      props.detaljiSecondaryClicked(
                        "osoba",
                        revPartner.idOsobe,
                        revPartner.vrOsobe,
                        false
                      )
                    }
                  >
                    <ZoomInOutlined />
                  </ButtonComponent>
                </td>
              </tr>
            ))
          ) : (
            <tr key={`osoba-drustvo`}>
              <td colSpan="3"></td>
            </tr>
          )}
        </tbody>
      </Table>

      <h5>Članovi / dioničari revizorskog društva</h5>
      <Table responsive bordered hover>
        <thead>
          <tr className="tr_table">
            <th scope="col">Naziv društva / Ime i prezime</th>
            <th scope="col">Poslovna adresa</th>
          </tr>
        </thead>
        <tbody>
          {dionicari.length > 0 ? (
            dionicari.map((dionicar, index) => (
              <tr key={`dionicari${index}`}>
                <td>
                  {dionicar.naziv
                    ? dionicar.naziv
                    : dionicar.ime && dionicar.prezime
                    ? dionicar.ime + " " + dionicar.prezime
                    : noDataMessage}
                </td>
                <td>
                  <table>
                    <tbody>
                      {dionicar.ulicaKbr ? (
                        <tr>
                          <td className="inner-td">
                            <b>Ulica i kbr: </b>
                            {dionicar.ulicaKbr}
                          </td>
                        </tr>
                      ) : null}
                      {dionicar.brPoste || dionicar.nazNaselja ? (
                        <tr>
                          <td className="inner-td">
                            <b>Grad: </b>
                            {dionicar.brPoste}
                            {dionicar.nazNaselja && " " + dionicar.nazNaselja}
                          </td>
                        </tr>
                      ) : null}

                      {dionicar.drzava ? (
                        <tr>
                          <td className="inner-td">
                            <b>Država: </b>
                            {dionicar.drzava}
                          </td>
                        </tr>
                      ) : null}
                    </tbody>
                  </table>
                </td>
              </tr>
            ))
          ) : (
            <tr key={`dionicari`}>
              <td colSpan="2"></td>
            </tr>
          )}
        </tbody>
      </Table>

      <h5>Uprava / upravni odbor</h5>
      <Table responsive bordered hover>
        <thead>
          <tr className="tr_table">
            <th scope="col">Ime i prezime</th>
            <th scope="col">Funkcija</th>
            <th scope="col">Poslovna adresa</th>
          </tr>
        </thead>
        <tbody>
          {clanoviUprave.length > 0 ? (
            clanoviUprave.map((clanUprave, index) => (
              <tr key={`clanovi-uprave${index}`}>
                <td>
                  {clanUprave.ime} {clanUprave.prezime}
                  {checkIfUserIsAdmin && clanUprave.oib
                    ? " (" + clanUprave.oib + ")"
                    : null}
                </td>
                <td>
                  {clanUprave.funkcija ? clanUprave.funkcija : noDataMessage}
                </td>
                <td>
                  <table>
                    <tbody>
                      {clanUprave.ulicaKbr ? (
                        <tr>
                          <td className="inner-td">
                            <b>Ulica i kbr: </b>
                            {clanUprave.ulicaKbr}
                          </td>
                        </tr>
                      ) : null}
                      {clanUprave.brPoste || clanUprave.nazNaselja ? (
                        <tr>
                          <td className="inner-td">
                            <b>Grad: </b>
                            {clanUprave.brPoste}
                            {clanUprave.nazNaselja &&
                              " " + clanUprave.nazNaselja}
                          </td>
                        </tr>
                      ) : null}
                      {clanUprave.drzava ? (
                        <tr>
                          <td className="inner-td">
                            <b>Država: </b>
                            {clanUprave.drzava}
                          </td>
                        </tr>
                      ) : null}
                    </tbody>
                  </table>
                </td>
              </tr>
            ))
          ) : (
            <tr key={`clanovi-uprave`}>
              <td colSpan="3"></td>
            </tr>
          )}
        </tbody>
      </Table>

      <h5>Revizorske mreže / članovi mreže / povezana društva</h5>
      <Table responsive bordered hover>
        <thead>
          <tr className="tr_table">
            <th scope="col">Naziv i sjedište mreže</th>
            <th scope="col">Adrese članova mreže</th>
            <th scope="col">Povezana društva i adrese</th>
            <th scope="col">
              Internetska stranica na kojoj se navedeni podaci mogu provjeriti
            </th>
          </tr>
        </thead>
        <tbody>
          {!mreza.nazMreze &&
          !mreza.ulicaKbr &&
          !mreza.brPoste &&
          !mreza.nazNaselja &&
          !clanMreze.length > 0 ? (
            <tr>
              <td colSpan="4"></td>
            </tr>
          ) : (
            <tr>
              {!mreza.nazMreze &&
              !mreza.ulicaKbr &&
              !mreza.brPoste &&
              !mreza.nazNaselja ? (
                <td></td>
              ) : (
                <td>
                  <table>
                    <tbody>
                      <tr>
                        <td className="inner-td">
                          <b>Naziv mreže: </b>
                          {mreza.nazMreze ? mreza.nazMreze : noDataMessage}
                        </td>
                      </tr>
                      {mreza.ulicaKbr ? (
                        <tr>
                          <td className="inner-td">
                            <b>Ulica i kbr: </b>
                            {mreza.ulicaKbr}
                          </td>
                        </tr>
                      ) : null}
                      {mreza.brPoste || mreza.nazNaselja ? (
                        <tr>
                          <td className="inner-td">
                            <b>Grad: </b>
                            {mreza.brPoste}
                            {mreza.nazNaselja && " " + mreza.nazNaselja}
                          </td>
                        </tr>
                      ) : null}
                      {mreza.nazDrzave ? (
                        <tr>
                          <td className="inner-td">
                            <b>Država: </b>
                            {mreza.nazDrzave}
                          </td>
                        </tr>
                      ) : null}
                    </tbody>
                  </table>
                </td>
              )}
              <td className="hr-divider">
                {clanoviMreze.length > 0
                  ? clanoviMreze.map((clanMreza, index) => (
                      <>
                        <table key={`clanovi-mreze${index}`}>
                          <tbody>
                            <tr>
                              <td className="inner-td">
                                <b>Naziv mreže: </b>
                                {clanMreza.nazMreze
                                  ? clanMreza.nazMreze
                                  : noDataMessage}
                              </td>
                            </tr>
                            {clanMreza.ulicaKbr ? (
                              <tr>
                                <td className="inner-td">
                                  <b>Ulica i kbr: </b>
                                  {clanMreza.ulicaKbr}
                                </td>
                              </tr>
                            ) : null}
                            {clanMreza.brPoste || clanMreza.nazNaselja ? (
                              <tr>
                                <td className="inner-td">
                                  <b>Grad: </b>
                                  {clanMreza.brPoste}
                                  {clanMreza.nazNaselja &&
                                    " " + clanMreza.nazNaselja}
                                </td>
                              </tr>
                            ) : null}
                            {clanMreza.nazDrzave ? (
                              <tr>
                                <td className="inner-td">
                                  <b>Država: </b>
                                  {clanMreza.nazDrzave}
                                </td>
                              </tr>
                            ) : null}
                          </tbody>
                        </table>
                        <hr />
                      </>
                    ))
                  : null}
              </td>
              <td className="hr-divider">
                {povezanaDrustva.length > 0
                  ? povezanaDrustva.map((povezanoDrustvo, index) => (
                      <>
                        <table key={`povezano-drustvo${index}`}>
                          <tbody>
                            <tr>
                              <td className="inner-td">
                                <b>Naziv društva: </b>
                                {povezanoDrustvo.nazDrustva
                                  ? povezanoDrustvo.nazDrustva
                                  : noDataMessage}
                              </td>
                            </tr>
                            {povezanoDrustvo.ulicaKbr ? (
                              <tr>
                                <td className="inner-td">
                                  <b>Ulica i kbr: </b>
                                  {povezanoDrustvo.ulicaKbr}
                                </td>
                              </tr>
                            ) : null}
                            {povezanoDrustvo.brPoste ||
                            povezanoDrustvo.nazNaselja ? (
                              <tr>
                                <td className="inner-td">
                                  <b>Grad: </b>
                                  {povezanoDrustvo.brPoste}
                                  {povezanoDrustvo.nazNaselja &&
                                    " " + povezanoDrustvo.nazNaselja}
                                </td>
                              </tr>
                            ) : null}
                            {povezanoDrustvo.nazDrzave ? (
                              <tr>
                                <td className="inner-td">
                                  <b>Država: </b>
                                  {povezanoDrustvo.nazDrzave}
                                </td>
                              </tr>
                            ) : null}
                          </tbody>
                        </table>
                        <hr />
                      </>
                    ))
                  : null}
              </td>
              <td className="hr-divider">
                {clanMreze.map((cm, index) => (
                  <>
                    <a href={"http://" + cm.web} target="_blank">
                      {cm.web}
                    </a>
                    <hr />
                  </>
                ))}
              </td>
            </tr>
          )}
        </tbody>
      </Table>

      <h5>Registracija kod nadležnih tijela drugih država članica</h5>
      <Table responsive bordered hover>
        <thead>
          <tr className="tr_table">
            <th scope="col">Naziv nadležnog tijela</th>
            <th scope="col">Adresa nadležnog tijela</th>
            <th scope="col">Broj i datum registracije</th>
          </tr>
        </thead>
        <tbody>
          {regDrustvaDrugeDrzave.length > 0 ? (
            regDrustvaDrugeDrzave.map((regDrustvoDrDrzava, index) =>
              !regDrustvoDrDrzava.brReg &&
              !regDrustvoDrDrzava.datReg &&
              !regDrustvoDrDrzava.nazTijela &&
              !regDrustvoDrDrzava.ulicaKbr &&
              !regDrustvoDrDrzava.brPoste &&
              !regDrustvoDrDrzava.nazNaselja ? (
                <tr key={`reg-drustvo-druge-drzave${index}`}>
                  <td colSpan="3"></td>
                </tr>
              ) : (
                <tr key={`reg-drustvo-druge-drzave${index}`}>
                  <td>
                    {regDrustvoDrDrzava.nazTijela
                      ? regDrustvoDrDrzava.nazTijela
                      : noDataMessage}
                  </td>
                  <td>
                    <table>
                      <tbody>
                        {regDrustvoDrDrzava.ulicaKbr ? (
                          <tr>
                            <td className="inner-td">
                              <b>Ulica i kbr: </b>
                              {regDrustvoDrDrzava.ulicaKbr}
                            </td>
                          </tr>
                        ) : null}
                        {regDrustvoDrDrzava.brPoste ||
                        regDrustvoDrDrzava.nazNaselja ? (
                          <tr>
                            <td className="inner-td">
                              <b>Grad: </b>
                              {regDrustvoDrDrzava.brPoste}
                              {regDrustvoDrDrzava.nazNaselja &&
                                " " + regDrustvoDrDrzava.nazNaselja}
                            </td>
                          </tr>
                        ) : null}
                        {regDrustvoDrDrzava.nazivDrzave ? (
                          <tr>
                            <td className="inner-td">
                              <b>Država: </b>
                              {regDrustvoDrDrzava.nazivDrzave}
                            </td>
                          </tr>
                        ) : null}
                      </tbody>
                    </table>
                  </td>
                  <td>
                    <table>
                      <tbody>
                        <tr>
                          <td className="inner-td">
                            <b>Broj registracije: </b>
                            {regDrustvoDrDrzava.brReg
                              ? regDrustvoDrDrzava.brReg
                              : noDataMessage}
                          </td>
                        </tr>
                        <tr>
                          <td className="inner-td">
                            <b>Datum registracije: </b>
                            {regDrustvoDrDrzava.datReg
                              ? regDrustvoDrDrzava.datReg
                              : noDataMessage}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              )
            )
          ) : (
            <tr key={`reg-drustvo-druge-drzave`}>
              <td colSpan="3"></td>
            </tr>
          )}
        </tbody>
      </Table>

      <h5>
        Registracija u drugoj državi članici za obavljanje revizije u trećoj
        zemlji
      </h5>
      <Table responsive bordered hover>
        <thead>
          <tr className="tr_table">
            <th scope="col">Naziv nadležnog tijela</th>
            <th scope="col">Adresa nadležnog tijela</th>
            <th scope="col">Broj i datum registracije</th>
          </tr>
        </thead>
        <tbody>
          {regDrustvaTrecaZemlja.length > 0 ? (
            regDrustvaTrecaZemlja.map((regDrustvoTrZemlja, index) =>
              !regDrustvoTrZemlja.brReg &&
              !regDrustvoTrZemlja.datReg &&
              !regDrustvoTrZemlja.nazTijela &&
              !regDrustvoTrZemlja.ulicaKbr &&
              !regDrustvoTrZemlja.brPoste &&
              !regDrustvoTrZemlja.nazNaselja ? (
                <tr key={`reg-drustva-treca-zemlja${index}`}>
                  <td colSpan="3"></td>
                </tr>
              ) : (
                <tr key={`reg-drustva-treca-zemlja${index}`}>
                  <td>
                    {regDrustvoTrZemlja.nazTijela
                      ? regDrustvoTrZemlja.nazTijela
                      : noDataMessage}
                  </td>
                  <td>
                    <table>
                      <tbody>
                        {regDrustvoTrZemlja.ulicaKbr ? (
                          <tr>
                            <td className="inner-td">
                              <b>Ulica i kbr: </b>
                              {regDrustvoTrZemlja.ulicaKbr}
                            </td>
                          </tr>
                        ) : null}
                        {regDrustvoTrZemlja.brPoste ||
                        regDrustvoTrZemlja.nazNaselja ? (
                          <tr>
                            <td className="inner-td">
                              <b>Grad: </b>
                              {regDrustvoTrZemlja.brPoste}
                              {regDrustvoTrZemlja.nazNaselja &&
                                " " + regDrustvoTrZemlja.nazNaselja}
                            </td>
                          </tr>
                        ) : null}
                        {regDrustvoTrZemlja.nazivDrzave ? (
                          <tr>
                            <td className="inner-td">
                              <b>Država: </b>
                              {regDrustvoTrZemlja.nazivDrzave}
                            </td>
                          </tr>
                        ) : null}
                      </tbody>
                    </table>
                  </td>
                  <td>
                    <table>
                      <tbody>
                        <tr>
                          <td className="inner-td">
                            <b>Broj registracije: </b>
                            {regDrustvoTrZemlja.brReg
                              ? regDrustvoTrZemlja.brReg
                              : noDataMessage}
                          </td>
                        </tr>
                        <tr>
                          <td className="inner-td">
                            <b>Datum registracije: </b>
                            {regDrustvoTrZemlja.datReg
                              ? regDrustvoTrZemlja.datReg
                              : noDataMessage}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              )
            )
          ) : (
            <tr key={`reg-drustva-treca-zemlja`}>
              <td colSpan="3"></td>
            </tr>
          )}
        </tbody>
      </Table>

      <h5>
        Nadležno tijelo države članice odgovorno za nadzor osiguranja kvalitete
        rada i nadzor ovlaštenih revizora i revizorskih društava
      </h5>
      <Table responsive bordered hover>
        <thead>
          <tr className="tr_table">
            <th scope="col">Naziv nadležnog tijela</th>
            <th scope="col">Adresa nadležnog tijela</th>
          </tr>
        </thead>
        <tbody>
          {regDrustvaNadzor.length > 0 ? (
            regDrustvaNadzor.map((nadleznoTijelo, index) =>
              !nadleznoTijelo.nazTijela &&
              !nadleznoTijelo.ulicaKbr &&
              !nadleznoTijelo.brPoste &&
              !nadleznoTijelo.nazNaselja ? (
                <tr key={`reg-drustvo-nadzor${index}`}>
                  <td colSpan="2"></td>
                </tr>
              ) : (
                <tr key={`reg-drustvo-nadzor${index}`}>
                  <td>
                    {nadleznoTijelo.nazTijela
                      ? nadleznoTijelo.nazTijela
                      : noDataMessage}
                  </td>
                  <td>
                    <table>
                      <tbody>
                        {nadleznoTijelo.ulicaKbr ? (
                          <tr>
                            <td className="inner-td">
                              <b>Ulica i kbr: </b>
                              {nadleznoTijelo.ulicaKbr}
                            </td>
                          </tr>
                        ) : null}

                        {nadleznoTijelo.brPoste || nadleznoTijelo.nazNaselja ? (
                          <tr>
                            <td className="inner-td">
                              <b>Grad: </b>
                              {nadleznoTijelo.brPoste}
                              {nadleznoTijelo.nazNaselja &&
                                " " + nadleznoTijelo.nazNaselja}
                            </td>
                          </tr>
                        ) : null}
                        {nadleznoTijelo.nazivDrzave ? (
                          <tr>
                            <td className="inner-td">
                              <b>Država: </b>
                              {nadleznoTijelo.nazivDrzave}
                            </td>
                          </tr>
                        ) : null}
                      </tbody>
                    </table>
                  </td>
                </tr>
              )
            )
          ) : (
            <tr key={`reg-drustvo-nadzor`}>
              <td colSpan="2"></td>
            </tr>
          )}
        </tbody>
      </Table>

      <h5>Izrečene odluke i nadzorne mjere</h5>
      <Table responsive bordered hover>
        <thead>
          <tr className="tr_table">
            <th scope="col">Vrsta mjere</th>
            <th scope="col">Rješenje</th>
            <th scope="col">Broj i datum rješenja</th>
            {checkIfUserIsAdmin ? (
              <th scope="col">Datum dostave rješenja subjektu</th>
            ) : (
              ""
            )}
            {/* <th scope="col">Napomena</th> */}
            <th scope="col">Upravni spor</th>
            <th scope="col">Datum pravomoćnosti</th>
            <th scope="col">Prekršajni postupak</th>
            {checkIfUserIsAdmin || userRole === "ROLE_KORISNIK" ? (
              <th scope="col">Datum brisanja</th>
            ) : (
              ""
            )}
          </tr>
        </thead>
        <tbody>
          {mjere.length ? (
            mjere.map((mjera, index) => (
              <tr key={`mjere${index}`}>
                <td>{mjera.vrstaMjere ? mjera.vrstaMjere : noDataMessage}</td>
                <td className="ikona_dokument_td ant_batn">
                  <ButtonComponent
                    className="ikona_dokument"
                    variant="secondary"
                    onClick={(e) =>
                      props.downloadDocumentDrustvo(e, mjera.idMjereDrustva)
                    }
                  >
                    <PaperClipOutlined />
                  </ButtonComponent>
                  <table>
                    <tbody>
                      {mjera.napomena ? (
                        <tr>
                          <td className="inner-td">
                            <b>Napomena: </b>
                            {mjera.napomena}
                          </td>
                        </tr>
                      ) : null}
                    </tbody>
                  </table>
                </td>
                <td>
                  <table>
                    <tbody>
                      <tr>
                        <td className="inner-td">
                          <b>Broj rješenja: </b>
                          {mjera.brRjesenja ? mjera.brRjesenja : noDataMessage}
                        </td>
                        <td className="inner-td">
                          <b>Datum rješenja: </b>
                          {mjera.datRjesenja
                            ? mjera.datRjesenja
                            : noDataMessage}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
                {checkIfUserIsAdmin ? (
                  <td>
                    {mjera.datPreuzimanja
                      ? mjera.datPreuzimanja
                      : noDataMessage}
                  </td>
                ) : null}
                <td className="ikona_dokument_td ant_batn">
                  <ButtonComponent
                    className="ikona_dokument"
                    variant="secondary"
                    onClick={(e) =>
                      props.downloadDocumentUSDrustvo(e, mjera.idMjereDrustva)
                    }
                    disabled={mjera.nazivDok2 ? false : true}
                  >
                    <PaperClipOutlined />
                  </ButtonComponent>
                  <table>
                    <tbody>
                      {mjera.napomena2 ? (
                        <tr>
                          <td className="inner-td">
                            <b>Napomena: </b>
                            {mjera.napomena2}
                          </td>
                        </tr>
                      ) : null}
                    </tbody>
                  </table>
                </td>
                <td>
                  {mjera.datPravomocnosti
                    ? mjera.datPravomocnosti
                    : noDataMessage}
                </td>
                <td className="ikona_dokument_td ant_batn">
                  <ButtonComponent
                    className="ikona_dokument"
                    variant="secondary"
                    onClick={(e) =>
                      props.downloadDocumentPPDrustvo(e, mjera.idMjereDrustva)
                    }
                    disabled={mjera.nazivDok3 ? false : true}
                  >
                    <PaperClipOutlined />
                  </ButtonComponent>
                  <table>
                    <tbody>
                      {mjera.napomena3 ? (
                        <tr>
                          <td className="inner-td">
                            <b>Napomena:</b>
                            {mjera.napomena3}
                          </td>
                        </tr>
                      ) : null}
                    </tbody>
                  </table>
                </td>
                {checkIfUserIsAdmin || userRole === "ROLE_KORISNIK" ? (
                  <td>
                    {mjera.datBrisanja ? mjera.datBrisanja : noDataMessage}
                  </td>
                ) : null}
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="8"></td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  );
};

export default RevizorskaDrustvaDrugihDrzavaClanicaDetaljiTable;
